module.exports = __webpack_public_path__ + "assets/img/4-2.7c4eeeab.png";